import { render, staticRenderFns } from "./AppFiltro.vue?vue&type=template&id=56b6caba&scoped=true"
import script from "./AppFiltro.vue?vue&type=script&lang=js"
export * from "./AppFiltro.vue?vue&type=script&lang=js"
import style0 from "./AppFiltro.vue?vue&type=style&index=0&id=56b6caba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6caba",
  null
  
)

export default component.exports